// FOR FORMATE OPTIONS
export const formatOptionsForSelect = (
  options = [],
  language = "en",
  labelKey = "title",
  valueKey = "_id"
) => {
  return options.map((option) => ({
    name: option?.[labelKey]?.[language] || option?.[labelKey]?.en || "",
    value: option?.[valueKey],
  }));
};

export const formatOptionsName = (
  options = [],
  language = "en",
  labelKey = "name",
  valueKey = "_id"
) => {
  return options.map((option) => ({
    name:
      language === "en"
        ? option?.[labelKey]
        : option?.[`${labelKey}Ar`] || option?.[labelKey],
    value: option?.[valueKey],
  }));
};

export const formatAPIUrlOptions = (
  options = [],
  labelKey = "url",
  valueKey = "url"
) => {
  return options.map((option) => ({
    name: option?.[labelKey],
    value: option?.[valueKey],
  }));
};
export const formatOptionsNameWithLangObject = (
  options = [],
  language = "en",
  labelKey = "name",
  valueKey = "_id"
) => {
  return options.map((option) => ({
    name:
      option?.[labelKey]?.[language] ??
      option?.[labelKey]?.en ??
      "",
    value: option?.[valueKey],
  }));
};
